import styled from 'styled-components';

import { colors } from '../../styles/tokens';

export const Container = styled.div`
  display: flex;
  align-items: center;
  > span {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.onSurfaceVariant};
    margin-right: 8px;
  }
  > div {
    flex: 1;
    height: 1px;
    background-color: ${colors.outlineVariant};
  }
`;
